import React, { useCallback } from 'react';

import { INSTRUCTOR_CATEGORIES } from '@classCreation/data/instructorCategories';
import InstructorSelect from 'components/InstructorSelect';

export default function SbatGroupPrimaryInstructorSelect({
  onInstructorsChange,
  ...remainingProps
}) {
  const handleInstructorsChange = useCallback(
    (newInstructor) => {
      onInstructorsChange((prevInstructors) => ({
        ...prevInstructors,
        [INSTRUCTOR_CATEGORIES.primary]: newInstructor,
      }));
    },
    [onInstructorsChange]
  );

  return (
    <InstructorSelect
      {...remainingProps}
      placeholder="Select Primary Instructor"
      onChange={handleInstructorsChange}
    />
  );
}
